<template>
  <div class="container">
    <!-- <div class="row justify-content-center">
      <div class="col-md-6">
        <span class="badge badge-danger my-3" style="font-size: 1.3rem"
          >Total icons: {{ icons.length }}</span
        >
        <br />
        <ul class="list-group">
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
            v-for="(icon, index) in icons"
            :key="index"
          >
            {{ icon }} :
            <span class="badge badge-light" style="font-size: 1.3rem">
              <i :class="`${icon}`" class="colored"></i
            ></span>
          </li>
        </ul>
      </div>
    </div> -->

    <button class="btn btn-success my-3" @click="addField((input = ''), filters)">Add Field</button>

    <div
      v-for="(input, index) in filters"
      :key="`phoneInput-${index}`"
      class="input wrapper flex items-center"
    >
      <div class="d-flex">
        <select
          name="select-filter"
          class="form-control w-50"
          v-model="selectedFilterName[index]"
          @change="onSelectFilterChange"
        >
          <option>Location</option>
          <option>City (distance)</option>
          <option>Employment type</option>
          <option>Competences</option>
          <option>Relocation</option>
        </select>

        <input
          v-if="selectedFilterName[index] == 'Location'"
          v-model="input['location']"
          type="text"
          class
          placeholder="Location"
        />

        <input
          v-if="selectedFilterName[index] == 'City (distance)'"
          v-model="input['City (distance)']"
          type="text"
          class=""
          placeholder="City (distance)"
        />

        <svg
          @click="addField(input, filters)"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          class="ml-2 cursor-pointer"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill="green"
            d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
          />
        </svg>

        <svg
          @click="removeField(index, filters)"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          class="ml-2 cursor-pointer"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            fill="#EC4899"
            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
          />
        </svg>
      </div>

      <span>{ {{ filters.phone }} }</span>
    </div>
  </div>
</template>

<script>
/* import CustomMainModal from '../Modals/CustomMainModal';
 
import TagInput from '../common/Tags/TagInput';
import Table from '../common/CustomTable/Table';

import format from 'date-fns/format'; */

export default {
  name: 'my-tour',
  data: () => ({
    selectedFilterName: [],
    step: 0,
    selected: [],
    selectedText: [],
    filters: [],
    icons: [
      'devicon-dot-net-plain',
      'devicon-csharp-plain',
      'devicon-aarch64-plain',
      'devicon-aftereffects-plain',
      'devicon-less-plain-wordmark',
      'devicon-amazonwebservices-plain',
      'devicon-android-plain',
      'devicon-apache-plain',
      'devicon-appcelerator-plain',
      'devicon-apple-plain',
      'devicon-appwrite-plain',
      'devicon-atom-plain',
      'devicon-babel-plain',
      'devicon-bash-plain',
      'devicon-behance-plain',
      'devicon-bitbucket-plain',
      'devicon-bootstrap-plain',
      'devicon-bower-plain',
      'devicon-c-plain',
      'devicon-cplusplus-plain',
      'devicon-ceylon-plain',
      'devicon-chrome-plain',
      'devicon-clojure-plain',
      'devicon-clojurescript-plain',
      'devicon-codeigniter-plain',
      'devicon-codepen-plain',
      'devicon-coffeescript-plain',
      'devicon-composer-plain',
      'devicon-confluence-plain',
      'devicon-css3-plain',
      'devicon-cucumber-plain',
      'devicon-devicon-plain',
      'devicon-docker-plain',
      'devicon-kubernetes-plain',
      'devicon-jenkins-plain',
      'devicon-gradle-plain',
      'devicon-doctrine-plain',
      'devicon-drupal-plain',
      'devicon-electron-original',
      'devicon-eleventy-plain',
      'devicon-elixir-plain',
      'devicon-elm-plain',
      'devicon-erlang-plain',
      'devicon-facebook-plain',
      'devicon-firebase-plain',
      'devicon-firefox-plain',
      'devicon-flutter-plain',
      'devicon-foundation-plain',
      'devicon-fsharp-plain',
      'devicon-gimp-plain',
      'devicon-git-plain',
      'devicon-github-plain',
      'devicon-gitlab-plain',
      'devicon-go-plain',
      'devicon-google-plain',
      'devicon-grails-plain',
      'devicon-groovy-plain',
      'devicon-grunt-plain',
      'devicon-gulp-plain',
      'devicon-handlebars-plain',
      'devicon-haskell-plain',
      'devicon-haxe-plain',
      'devicon-heroku-plain',
      'devicon-html5-plain',
      'devicon-illustrator-plain',
      'devicon-inkscape-plain',
      'devicon-intellij-plain',
      'devicon-ionic-original',
      'devicon-jasmine-plain',
      'devicon-java-plain',
      'devicon-javascript-plain',
      'devicon-angularjs-plain',
      'devicon-backbonejs-plain',
      'devicon-react-plain',
      'devicon-vuejs-plain',
      'devicon-jquery-plain',
      'devicon-krakenjs-plain',
      'devicon-express-original',
      'devicon-ember-original-wordmark',
      'devicon-meteor-plain',
      'devicon-nodejs-plain',
      'devicon-d3js-plain',
      'devicon-gatsby-plain',
      'devicon-nestjs-plain',
      'devicon-redux-plain',
      'devicon-jeet-plain',
      'devicon-jetbrains-plain',
      'devicon-jupyter-plain',
      'devicon-kotlin-plain',
      'devicon-linkedin-plain',
      'devicon-linux-plain',
      'devicon-redhat-plain',
      'devicon-debian-plain',
      'devicon-ubuntu-plain',
      'devicon-materialui-plain',
      'devicon-matlab-plain',
      'devicon-mocha-plain',
      'devicon-mongodb-plain',
      'devicon-couchdb-plain',
      'devicon-moodle-plain',
      'devicon-nginx-plain',
      'devicon-nodewebkit-plain',
      'devicon-npm-original-wordmark',
      'devicon-objectivec-plain',
      'devicon-ocaml-plain',
      'devicon-photoshop-plain',
      'devicon-php-plain',
      'devicon-laravel-plain',
      'devicon-cakephp-plain',
      'devicon-phpstorm-plain',
      'devicon-symfony-plain',
      'devicon-zend-plain',
      'devicon-premierepro-plain',
      'devicon-protractor-plain',
      'devicon-pycharm-plain',
      'devicon-python-plain',
      'devicon-django-plain',
      'devicon-flask-plain',
      'devicon-r-plain',
      'devicon-rails-plain',
      'devicon-redis-plain',
      'devicon-rocksdb-plain',
      'devicon-ruby-plain',
      'devicon-rubymine-plain',
      'devicon-rust-plain',
      'devicon-safari-plain',
      'devicon-sass-plain',
      'devicon-scala-plain',
      'devicon-sequelize-plain',
      'devicon-sketch-line',
      'devicon-slack-plain',
      'devicon-sourcetree-plain',
      'devicon-sqlalchemy-plain',
      'devicon-oracle-plain',
      'devicon-postgresql-plain',
      'devicon-mysql-plain',
      'devicon-ssh-plain',
      'devicon-stylus-original',
      'devicon-swift-plain',
      'devicon-gatling-plain',
      'devicon-tomcat-line',
      'devicon-travis-plain',
      'devicon-trello-plain',
      'devicon-twitter-plain',
      'devicon-typescript-plain',
      'devicon-typo3-plain',
      'devicon-uwsgi-plain',
      'devicon-vagrant-plain',
      'devicon-vim-plain',
      'devicon-visualstudio-plain',
      'devicon-webpack-plain',
      'devicon-webstorm-plain',
      'devicon-windows8-plain',
      'devicon-woocommerce-plain',
      'devicon-wordpress-plain',
      'devicon-xd-plain',
      'devicon-yarn-plain',
      'devicon-yii-plain',
      'devicon-yunohost-plain colored-icon',
      'devicon-vscode-plain',
      'devicon-salesforce-plain',
      'devicon-magento-original',
      'devicon-circleci-plain',
    ],
  }),
  methods: {
    onSelectFilterChange(e) {
      console.log('changed select', e);
    },
    addField(_value, fieldType) {
      // console.log('addField: ', value, fieldType);

      fieldType.push({});
    },
    removeField(index, fieldType) {
      fieldType.splice(index, 1);
      this.selectedFilterName.splice(index, 1);
    },
  },
  mounted() {
    /* this.$tours['myTour'].start(); */
  },
};
</script>

<style lang="scss" scoped>
.colored-icon {
  background-color: grey;
}
</style>
